var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "boots_armor",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,7.6c3.63,0,10.02,0,13.96,0c1.73,0,2.99,1.64,2.54,3.32l-5.44,20.46c-0.07,0.28,0.03,0.57,0.28,0.72 c0.99,0.62,4.64,2.57,8.15,5.78c0.12,0.11,2.92-0.03,3.09-0.01c2.31,0.2,3.97-0.08,5.05,4.7c0.09,0.42-0.21,0.82-0.64,0.82 c-4.21,0-24.43,0-28.17,0c-0.34,0-0.63-0.26-0.66-0.61c-0.15-1.82-0.4-7.23,1.74-9.32c0.17-0.16,0.25-0.37,0.2-0.6 c-0.39-1.74-2.09-9.83-2.74-22.48C10.29,8.88,11.48,7.6,13,7.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoots);
export default __webpack_public_path__ + "static/media/boots.f7ee438103562a681ea059c335b8ae86.svg";
export { ForwardRef as ReactComponent };